import { ApplicationConfig, importProvidersFrom } from '@angular/core';
import { provideRouter, withComponentInputBinding } from '@angular/router';
import { provideAnimations } from '@angular/platform-browser/animations';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { provideStore } from '@ngrx/store';
import { provideToastr } from 'ngx-toastr';
import { BrowserModule } from '@angular/platform-browser';

import { routes } from './app.routes';
import { providerReducer } from './store/provider/provider.reducer';
import { appReducer } from './store/app/app.reducer';
import { GraphQLModule } from '../core/graphql.module';
import { merchantReducer } from './store/merchant/merchant.reducer';
import { userReducer } from './store/user/user.reducer';
import { productReducer } from './store/product/product.reducer';
import { merchantSubscriptionReducer } from './store/merchant-subscription/merchant-subscription.reducer';
import { transactionReducer } from './store/transaction/transaction.reducer';
import { endpointReducer } from './store/endpoint/endpoint.reducer';

export const appConfig: ApplicationConfig = {
  providers: [
    importProvidersFrom(BrowserModule, GraphQLModule),
    provideRouter(routes, withComponentInputBinding()),
    provideAnimations(),
    provideAnimationsAsync(),
    provideStore({
      app: appReducer,
      user: userReducer,
      provider: providerReducer,
      endpoint: endpointReducer,
      merchant: merchantReducer,
      merchantSubscription: merchantSubscriptionReducer,
      product: productReducer,
      transaction: transactionReducer,
    }),
    provideToastr({}),
  ],
};
